import { render, staticRenderFns } from "./VideoProduct.vue?vue&type=template&id=b580c758&scoped=true&"
import script from "./VideoProduct.vue?vue&type=script&lang=js&"
export * from "./VideoProduct.vue?vue&type=script&lang=js&"
import style0 from "./VideoProduct.vue?vue&type=style&index=0&id=b580c758&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b580c758",
  null
  
)

export default component.exports